'use client';

import { useMemo } from 'react';
import { useTranslations } from 'next-intl';
import { PerformanceLabTypeformSnippet } from 'components/performance-lab/PerformanceLabTypeformSnippet';
import {
  buildTypeformTrackingFromUrl,
  getPageUrlUtmSource,
} from 'utils/buildTypeformTrackingParams';
import { UHPL_PARTNERS_TYPEFORM_ID } from './plPartnersConstants';
import styles from './PlPartnersTypeformModal.module.css';

export const PlPartnersTypeformModal = () => {
  const t = useTranslations('performance-lab');
  const trackingParams = useMemo(
    () =>
      buildTypeformTrackingFromUrl({
        utm_source: getPageUrlUtmSource('performance-lab'),
        utm_medium: 'partners_modal',
        utm_campaign: 'performance_lab_partners',
      }),
    [],
  );

  return (
    <div className={styles.container}>
      <PerformanceLabTypeformSnippet
        typeformId={UHPL_PARTNERS_TYPEFORM_ID}
        frameTitle={t('partnersPage.typeformTitle')}
        className="typeform-container"
        trackingParams={trackingParams}
      />
    </div>
  );
};
